import { useConstant } from '@eturi/react'
import { composeValidators, maxLength, minLength, required } from '../../../validators'
import { MAX_USERNAME_LENGTH, MIN_USERNAME_LENGTH } from '../../../validators/constants'
import { createInputField } from '../../Fields/createInputField'

export const ChildNameField = () => {
	const validateName = useConstant(() =>
		composeValidators(
			required('error_strings.empty_child_name'),
			minLength('error_strings.invalid_name', MIN_USERNAME_LENGTH),
			maxLength('error_strings.name_max_limit_error', MAX_USERNAME_LENGTH),
		),
	)

	const UsernameFieldInput = useConstant(() =>
		createInputField(
			{ name: 'name', validate: validateName },
			{ maxLength: 70, placeholder: 'form_controls.child_name.placeholder' },
			'OPUname',
		),
	)

	return <UsernameFieldInput className="!text-base !text-[#1c1c28] bg-transparent" />
}
